module.exports = "https://cdn.dove.it/_next/static/public/assets/cities/bologna.890f471bb214f752914602c6d5271244.jpg";